import React from 'react'
import styled from 'react-emotion'
import { avatarSize } from '../style'
import { connect } from 'react-redux'
import { firebaseConnect, getVal } from 'react-redux-firebase'
import { compose, setStatic } from 'recompose'

const nameToColor = name =>
  '#' +
  ((parseInt(name.replace(/[^\w]/g, ''), 36) % 9371648) + 5540032).toString(16)
const nameToInitials = name => {
  if (!name || !name.match) return ''
  const match = name.match(/^[^\w]*(\w)(?:.* (\w))?/)
  if (!match) return name.subsrt(0, 2)
  return match
    .slice(1, 3)
    .join('')
    .toUpperCase()
}

export const Avatar = styled(({ name = '', className }) => (
  <span className={className} title={name}>
    {nameToInitials(name)}
  </span>
))(({ name = '', large }) => {
  const size = large ? 60 : avatarSize
  return {
    width: size,
    height: size,
    borderRadius: size / 2,
    backgroundColor: nameToColor(name),
    fontWeight: 'bold',
    fontSize: large ? 24 : 'inherit',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

const AvatarContainer = compose(
  firebaseConnect(({ name, userId }) =>
    !name && userId ? [`/users/public/${userId}`] : []
  ),
  connect((state, { name, userId }) => ({
    name:
      name || getVal(state.firebase, `data/users/public/${userId}/displayName`)
  })),
  setStatic('className', Avatar.toString())
)

export default AvatarContainer(Avatar)
